import React from 'react'
import { motion } from 'framer-motion';
import * as Images from './../assets/images';

function PaymentPopup({ onClose, count, message, onPayNow }) {
    const heightClass = count?.toString()?.length === 4
        ? 'text-[30px]'
        :'text-[42px]'
    return (
        <div
            className="flex items-center justify-center bg-opacityblack overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            // onClick={onClose}
        >
            <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.3 }}
                className="bg-white rounded-lg shadow-lg w-[90%] sm:max-w-[28rem]"
                onClick={(e) => e.stopPropagation()}
            >
                <div className='px-4 pt-4 space-y-2 flex flex-col items-center'>
                    <h2 className='text-center sm:max-w-[76%] text-[#000000] font-medium text-[20px]'>{message}</h2>
                    <div className='relative flex justify-center items-center'>
                        <img className='h-[9rem] xl:h-[10rem]' src={Images.paymentpopupicon} alt='' />
                        <div
                            className={`font-bold absolute top-1/2 left-[47%] transform -translate-x-1/2 -translate-y-1/2 ${heightClass}`}
                        >
                            {count}
                        </div>
                    </div>
                    <p className='text-center sm:max-w-[70%] text-[16px]'>Buy a calling pack Now and start interacting with them</p>
                </div>
                <div className="border-t border-dashed border-[#D71920] my-2"></div>
                <div className='px-4 pb-4 space-y-2'>
                    <p className='font-bold text-[18px]'>Calling Pack Benefits:</p>
                    <div className='grid grid-cols-2 gap-6 mt-2'>
                        <div className='flex items-center gap-2'>
                            <img className='h-[2rem] w-[2rem] xl:h-[2.5rem] xl:w-[2.5rem] object-contain' src={Images.PhoneNumberIcon} alt='' />
                            <p className='font-medium text-[13px] xl:text-[14px]'>View Phone <br /> Numbers</p>
                        </div>
                        <div className='flex items-center gap-2'>
                            <img className='h-[2rem] w-[2rem] xl:h-[2.5rem] xl:w-[2.5rem] object-contain' src={Images.HoroscopeIcon} alt='' />
                            <p className='font-medium text-[13px] xl:text-[14px]'>View <br /> Horoscopes</p>
                        </div>
                        <div className='flex items-center gap-2'>
                            <img className='h-[2rem] w-[2rem] xl:h-[2.5rem] xl:w-[2.5rem] object-contain' src={Images.ChatMessageIcon} alt='' />
                            <p className='font-medium text-[13px] xl:text-[14px]'>Chat <br /> Messages</p>
                        </div>
                        <div className='flex items-center gap-2'>
                            <img className='h-[2rem] w-[2rem] xl:h-[2.5rem] xl:w-[2.5rem] object-contain' src={Images.PaymentWhatsappIcon} alt='' />
                            <p className='font-medium text-[13px] xl:text-[14px]'>
                                Get Matches
                                <span className='text-[#039511]'> via <br /> WhatsApp!</span>
                                <br />
                                <span className='text-[#D71920] text-[10px]'>(Add on Pack)</span>
                            </p>
                        </div>
                    </div>
                    <div className='flex flex-col justify-center items-center mt-4 space-y-2'>
                        <button onClick={onPayNow} className='bg-[#D10A11] text-white h-8 w-28 rounded font-medium'>
                            Pay Now!
                        </button>
                        <button onClick={onClose} className='w-28 border border-[#D10A11] text-[#D10A11] h-8 rounded font-medium'>
                            Cancel
                        </button>
                    </div>
                </div>
            </motion.div>
        </div>
    );
}

export default PaymentPopup